import * as path from "path";

export const coverageContractsPath = () => path.join("coverage", "instrumentedContracts");
